import { Tabs } from 'antd';
import React, { useEffect, useState } from 'react';
import { useHistory, useLocation, withRouter } from 'react-router-dom';
import InfoIconComponent from '../../../app/components/iconComponents/InfoIconComponent';
import gallerySvg from '../../../assets/gallery.svg';
import { ROUTES } from '../../../common/constants';

const CustomerTabs = ({ match: { params: { id } = {} } = {}, children }) => {
  const location = useLocation();
  const history = useHistory();
  const [activeKey, setActiveKey] = useState('INFORMATION');

  const infoTitle = (
    <div>
      <InfoIconComponent className="tab-icons" />
      <span className="card-title">Information</span>
    </div>
  );
  const infoTitleContacts = (
    <div>
      <InfoIconComponent className="tab-icons" />
      <span className="card-title">Contacts</span>
    </div>
  );

  const infoTitleProperties = (
    <div>
      <img src={gallerySvg} alt="info-icon" />
      <span className="card-title">Properties</span>
    </div>
  );

  useEffect(() => {
    if (
      location?.pathname?.includes('/edit') ||
      location?.pathname?.includes('/view') ||
      location?.pathname?.includes('/add')
    ) {
      setActiveKey('INFORMATION');
    }
    if (location?.pathname?.includes('contacts')) {
      setActiveKey('CONTACTS');
    }
    if (location?.pathname?.includes('properties')) {
      setActiveKey('PROPERTIES');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSelectTab = (key) => {
    switch (key) {
      case 'INFORMATION':
        if (location?.pathname?.includes('/edit')) {
          history?.push(`${ROUTES?.CUSTOMERS}/edit/${id}`);
        } else {
          history?.push(`${ROUTES?.CUSTOMERS}/view/${id}`);
        }
        break;

      case 'CONTACTS':
        if (location?.pathname?.includes('/edit')) {
          history?.push(`${ROUTES?.CUSTOMERS}/edit${ROUTES?.CONTACTS}/${id}`);
        } else {
          history?.push(`${ROUTES?.CUSTOMERS}/view${ROUTES?.CONTACTS}/${id}`);
        }
        break;

      case 'PROPERTIES':
        if (location?.pathname?.includes('/edit')) {
          history?.push(`${ROUTES?.CUSTOMERS}/edit${ROUTES?.PROPERTIES}/${id}`);
        } else {
          history?.push(`${ROUTES?.CUSTOMERS}/view${ROUTES?.PROPERTIES}/${id}`);
        }
        break;

      default:
        break;
    }
  };

  const tabItems = [
    {
      label: infoTitle,
      key: 'INFORMATION',
      children
    },
    !location?.pathname?.includes('/add') && {
      label: infoTitleContacts,
      key: 'CONTACTS',
      children
    },
    !location?.pathname?.includes('/add') && {
      label: infoTitleProperties,
      key: 'PROPERTIES',
      children
    }
  ];

  return (
    <div className="card-container">
      <Tabs
        type="card"
        items={tabItems}
        activeKey={activeKey}
        onChange={handleSelectTab}
      />
    </div>
  );
};

export default withRouter(CustomerTabs);
